/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useState, useRef, useCallback } from "react";
import useStyles from "./styles";
import SignatureCanvas from "react-signature-canvas";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import DialogBack from "./Components/DialogBack";
import DialogSignatureSuccess from "./Components/DialogSignatureSuccess";

import { Dialog, Slide, Container, Grid, Button } from "@material-ui/core";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const DialogSignature = memo(props => {
	const classes = useStyles();
	const { open, signatureRewardConfirm, handleClose } = props;
	const padRef = useRef(null);
	const [isImgSignature, setImgSignature] = useState(false);
	const [openBackDialog, setOpenBackDialog] = useState(false);
	const [isSuccessDialog, setSuccessDialog] = useState(false);

	const clearSignatureCanvas = useCallback(() => {
		padRef?.current?.clear();
	}, []);

	const handleCancel = event => {
		clearSignatureCanvas();
		setImgSignature(false);
	};

	const onSuccess = () => {
		setSuccessDialog(true);
	};

	const signature = signatureImage => {
		const params = {
			signature: signatureImage,
			onSuccess
		};
		signatureRewardConfirm(params);
	};

	const handleGetCanvas = useCallback(() => {
		const signatureImage = padRef?.current?.toDataURL();
		signature(signatureImage);
	}, []);

	const handleSignatureDone = () => {
		const dataUrl = padRef.current.toDataURL();
		if (dataUrl) {
			setImgSignature(true);
		}
	};

	return (
		<Dialog
			fullScreen
			open={open}
			onClose={handleClose}
			TransitionComponent={Transition}
		>
			<Container maxWidth="xs">
				<Grid classes={{ root: classes.root }}>
					<Grid classes={{ root: classes.header }}>
						<Grid classes={{ root: classes.rootHeader }}>
							<Grid
								classes={{ root: classes.iconGoBack }}
								onClick={() => {
									handleClose();
									setImgSignature(false);
								}}
							>
								<ArrowBackIcon />
							</Grid>
							<Grid>Xác nhận chữ ký</Grid>
						</Grid>
					</Grid>

					<Grid
						style={{
							padding: "16px 0px",
							height: `calc(100vh - 32px)`,
							overflowY: "auto"
						}}
					>
						<Grid classes={{ root: classes.wrapper }}>
							<SignatureCanvas
								ref={padRef}
								onEnd={handleSignatureDone}
							/>
						</Grid>

						<Grid style={{ textAlign: "center" }}>
							<Grid style={{ marginTop: 10 }}>
								<Button
									onClick={() => {
										if (!isImgSignature) {
											setOpenBackDialog(true);
											return;
										}
										handleGetCanvas();
									}}
									color="primary"
									variant="contained"
									classes={{ root: classes.btnSubmit }}
								>
									Xác nhận
								</Button>
							</Grid>
							<Grid style={{ marginTop: 10 }}>
								<Button
									onClick={() => {
										handleCancel();
									}}
									classes={{ root: classes.btnCancel }}
									variant="outlined"
								>
									Ký lại
								</Button>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
				<DialogBack
					open={openBackDialog}
					handleClose={() => {
						setOpenBackDialog(false);
					}}
				/>
				<DialogSignatureSuccess
					open={isSuccessDialog}
					handleClose={() => {
						setSuccessDialog(false);
						handleClose();
					}}
				/>
			</Container>
		</Dialog>
	);
});

export default DialogSignature;
